import React, { useContext, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';

const CouponStatusChangeModal = ({ modalDetails }) => {
	const modalCtx = useContext(ModalContext);
	const authCtx = useContext(AuthContext);
	const [loading, setLoading] = useState(false);
	const [clicked, setClicked] = useState(null);

	const { coupon, currentStatus } = modalDetails;

	const getStatusOptions = () => {
		switch (currentStatus) {
			case 'pending':
				return [
					{ status: 'approved', label: 'Make it Live', color: 'primary' },
					{ status: 'archived', label: 'Archive Coupon', color: 'secondary' }
				];
			case 'approved':
				return [
					{ status: 'pending', label: 'Move to Pending', color: 'secondary' },
					{ status: 'archived', label: 'Archive Coupon', color: 'secondary' }
				];
			case 'archived':
				return [
					{ status: 'approved', label: 'Make it Live', color: 'primary' },
					{ status: 'pending', label: 'Move to Pending', color: 'secondary' }
				];
			default:
				return [];
		}
	};

	const handleStatusChange = async (newStatus) => {
		setClicked(newStatus);
		setLoading(true);
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/coupon/${coupon.id}/status`, {
				method: 'PATCH',
				headers: { 
					'Content-Type': 'application/json', 
					Authorization: "Bearer " + authCtx.token 
				},
				body: JSON.stringify({ status: newStatus })
			});
			const data = await response.json();
			if (data.status === 'success') {
				modalCtx.closeModal();
				modalCtx.setPageUpdate({ 
					page: "Coupons", 
					couponId: coupon.id,
					status: newStatus
				});
			} else {
				console.error('Failed to update coupon status:', data.message);
			}
		} catch (error) {
			console.error('Error updating coupon status:', error);
		} finally {
			setLoading(false);
			setClicked(null);
		}
	}

	const statusOptions = getStatusOptions();

	return (
		<div className="modal-container">
			<div className='modal-header' style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<h1>Change Coupon Status</h1>
				<CloseRounded onClick={() => modalCtx.closeModal()}className="modal-close-icon"/>
			</div>
			<div className="modal-body">
				<span>Current status: <strong>{currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)}</strong></span>
				<br />
				<span>How would you like to change this coupon's status?</span>
			</div>
			<div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
				{statusOptions.map((option) => (
					<Button
						key={option.status}
						onClick={() => handleStatusChange(option.status)}
						disabled={loading}
						variant={option.color === 'primary' ? 'contained' : 'outlined'}
						color={option.color}
						style={{ minWidth: 160 }}
					>
						{loading && clicked === option.status ? (
							<CircularProgress 
								size={16} 
								style={{ 
									color: option.color === 'primary' ? '#fff' : '#1976d2', 
									marginRight: 8 
								}} 
							/>
						) : null}
						{option.label}
					</Button>
				))}
			</div>
		</div>
	);
}

export default CouponStatusChangeModal;
